<div class="report-page-root-container  attendance-exception-report-component-container  ">
  <div class="page-content">
    <div class="page-header">
      <img class="icon" src="assets/images/menu/svg/attendance-exception-report.svg" width="27">
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon" [src]="
              IsDownloading
                ? 'assets/images/animated/download/download-anim.svg'
                : 'assets/images/animated/download/download-no-anim.svg'
            " />
          <span class="action-btn-title">Export</span>
        </button>
        }
      </div>
    </div>
    <div class="page-details" style="overflow: hidden;">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <mat-form-field>
                <mat-label>Date From</mat-label>
                <input matInput [matDatepicker]="pickerFrom" formControlName="period_from" placeholder="DD-MM-YYYY">
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_from')?.invalid && (editForm.get('period_from')?.touched || editForm.get('period_from')?.dirty)">
                  <ng-container *ngIf="editForm.get('period_from')?.hasError('required')">
                    Please select a date.
                  </ng-container>
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Date To</mat-label>
                <input matInput [matDatepicker]="pickerTo" formControlName="period_to"
                  [min]="editForm.get('period_from')?.value" placeholder="DD-MM-YYYY">
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_to')?.invalid && (editForm.get('period_to')?.touched || editForm.get('period_to')?.dirty)">
                  <ng-container *ngIf="editForm.get('period_to')?.hasError('required')">
                    Please select a date.
                  </ng-container>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="row">
              <mat-form-field>
                <mat-label>Shop</mat-label>
                <input matInput formControlName="shop_id" [matAutocomplete]="shopAuto" (input)="filterShops()"
                  (focus)="filterShops()" autocomplete="off" placeholder="Select a shop">
                <button *ngIf="editForm.get('shop_id')?.value" matSuffix mat-icon-button aria-label="Clear"
                  (click)="clearShop()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #shopAuto="matAutocomplete" [displayWith]="displayShop">
                  <mat-option *ngFor="let shop of filteredShopList" [value]="shop"
                    [class.all-option]="shop.name === 'ALL'">
                    <span [style.font-weight]="shop.name === 'ALL' ? 'normal' : 'normal'">
                      {{ shop.name }}
                    </span>
                  </mat-option>
                </mat-autocomplete>
                <mat-error
                  *ngIf="editForm.get('shop_id')?.invalid && (editForm.get('shop_id')?.touched || editForm.get('shop_id')?.dirty)">
                  <ng-container *ngIf="editForm.get('shop_id')?.hasError('required')">
                    Shop is required.
                  </ng-container>
                  <ng-container *ngIf="editForm.get('shop_id')?.hasError('invalidShop')">
                    Please select a valid shop.
                  </ng-container>
                </mat-error>
              </mat-form-field>

            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>